export enum CustomerEnum {
    AYOR = "hammel",
    FVI = "fvi",
    DEFAULT = "default",
    PAUL = "paul"
}